import { graphql } from 'react-relay';
export const EnableSuperAdminMutation = graphql`
	mutation EnableSuperAdminMutation {
		enableSuperAdmin {
			user {
				id
				confluence {
					roles {
						isSuperAdmin
					}
				}
			}
		}
	}
`;
